package org.moxultimate.topwithmox.tech.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * TechTypeResponse
 * Data class representing a single type entry returned by GET /tech-type.
 *
 * @param id   Unique database identifier of the type.
 * @param type Type label string (e.g. "Tutorial", "Guide", "Review").
 */
@Serializable
data class TechTypeResponse(
    @SerialName("id") val id: Long? = null,
    @SerialName("type") val type: String? = null,
)
